import React, { useEffect, useState } from 'react';
import {
  Checkbox, FormControlLabel,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import Prompt from '../../layout/Prompt';
import {
  DigitalSection,
  DigitalSubmissionMeta,
  Enrollment,
  Trial,
} from '../../../redux/types';

type Props = {
  trial: Trial,
  enrollment: Enrollment;
  selectedSection: DigitalSection
  sectionSubmissionMeta: DigitalSubmissionMeta;
  showSubmissions?: boolean;
  optOutFromSection: (
    trialId: number, sectionId: number, enrollmentId: number, isOptOut: boolean) => void;
  highlightOptOut?: boolean;
  setHighlightOptOut?: React.Dispatch<React.SetStateAction<boolean>>;
  isEditorPrivileged?: boolean;
};

const SectionOptOut: React.FC<Props> = ({
  trial,
  enrollment,
  selectedSection,
  sectionSubmissionMeta,
  showSubmissions,
  optOutFromSection,
  highlightOptOut,
  setHighlightOptOut,
  isEditorPrivileged,
}: Props) => {
  const [showOptOutPrompt, setShowOptOutPrompt] = useState<boolean>(false);

  const cancelOptOut = () => {
    if (!!trial && !!selectedSection && !!enrollment) {
      optOutFromSection(trial.id, selectedSection.id, enrollment.id, false);
    }
  };
  const onConfirmOptOut = (confirm: boolean) => {
    if (confirm === false) {
      setShowOptOutPrompt(false);
      return;
    }
    if (!trial || !selectedSection || !enrollment) {
      return;
    }
    optOutFromSection(trial.id, selectedSection.id, enrollment.id, true);
    setShowOptOutPrompt(false);
  };

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    // remove highlight effect in after timeout
    if (setHighlightOptOut && highlightOptOut !== undefined) {
      timeout = setTimeout(() => {
        setHighlightOptOut(false);
      }, 1250);
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [setHighlightOptOut, highlightOptOut]);

  // ths opt-out checkbox is disabled if the submission is finalized or
  // if the user is not editor privileged.
  // It was not intended to be like this but we didnt disable it from exhibitB,
  // and Pascal found it useful for him to have it for editor privileged users.
  let isOptOutDisabled = false;
  if (sectionSubmissionMeta?.submissionFinalized || (showSubmissions && !isEditorPrivileged)) {
    isOptOutDisabled = true;
  }

  return (
    <>
      <FormControlLabel
        disabled={isOptOutDisabled}
        control={(
          <Checkbox
            checked={!!sectionSubmissionMeta?.isOptOut}
            onClick={
              !sectionSubmissionMeta
                ?.isOptOut ? () => setShowOptOutPrompt(true) : cancelOptOut
            }
          />
        )}
        label={<FormattedMessage id="survey.optOut" />}
        sx={{
          transition: 'background-color 0.5s ease-in-out',
          backgroundColor: highlightOptOut ? '#eff58c' : '',
        }}
      />
      <Prompt
        version={2}
        title={<FormattedMessage id="survey.optOutWarningTitle" values={{ sectionName: selectedSection.name }} />}
        action={onConfirmOptOut}
        display={showOptOutPrompt}
      >
        <FormattedMessage id="survey.optOutWarning" />
      </Prompt>
    </>
  );
};

export default SectionOptOut;
